import React from 'react';
import classNames from 'classnames';
import Icon from "@scentregroup/ui/components/icon";
import { pluralise } from '../../helpers';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const buildReviewLabel = reviewCount => "".concat(reviewCount, " ").concat(pluralise(reviewCount, 'rating'));

const ariaLabelForReview = (starRating, starTotal) => "Rated ".concat(starRating, " of ").concat(starTotal, " stars");

const StarRating = ({
  className,
  starRating,
  starTotal,
  reviewCount
}) => /*#__PURE__*/_jsxs("span", {
  "aria-label": ariaLabelForReview(starRating, starTotal),
  className: classNames(style.starRating, className),
  children: [[...Array(starTotal)].map((_, i) => /*#__PURE__*/_jsx(Icon, {
    type: "star",
    size: "small",
    className: classNames(style.star, {
      [style.starEmpty]: i >= starRating
    })
  }, i)), reviewCount && /*#__PURE__*/_jsx("span", {
    className: style.reviewText,
    children: buildReviewLabel(reviewCount)
  })]
});

StarRating.defaultProps = {
  starTotal: 5
};
export default StarRating;